var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (artwork) {
buf.push("<h1 class=\"iq-headline\">");
if ( artwork.related().partner.get('pre_qualify'))
{
buf.push("What artists do you collect?");
}
else
{
buf.push("<span>What artists do you collect?</span><span>(Optional)</span>");
}
buf.push("</h1><div class=\"iq-form stacked-form\"><div class=\"js-user-interests\"></div><div class=\"iq-sticky-spacer\"></div><div class=\"iq-sticky-bottom\"><button type=\"submit\" class=\"avant-garde-button-black is-block iq-next\">Next</button></div></div>");}.call(this,"artwork" in locals_for_with?locals_for_with.artwork:typeof artwork!=="undefined"?artwork:undefined));;return buf.join("");
};
module.exports = template;